import { baseTheme } from './baseTheme';

export const lightTheme = {
  ...baseTheme,
  colors:{
      white:'#fff',
      white2: '#fff',
      black:'rgb(47, 47, 47)',
      red: 'rgb(197, 31, 42)',
      red2:'#C51F2A',
      red3:'#DEDEDE',
      gray:'#2F2F2F',
      gray2:'#999999',
      gray3:'#717171',
      gray4:'#BFBFBF',
      gray5:'#DCDCDC',
      gray6:'rgba(0, 0, 0, 0.3)',
      gray7:'#F2F2F2',
      gray8: '#E8E8E8',
      gray9: '#7A7A7A',
      gray10: '#FAF8F8',
      blue:'#0B02C1',
      blue2:'#09046F',
      blue3:'#DBE2FC',
      blue4:'#03134F'
  },
  backgrounds:{
    white:'#fff',
    white2: '#fff',
    black:'rgb(47, 47, 47)',
    gray:'#2F2F2F',
    gray2:'#999999',
    gray3:'#717171',
    gray4:'#BFBFBF',
    gray5:'#DCDCDC',
    gray6:'rgba(0, 0, 0, 0.3)',
    gray7:'#F2F2F2',
    gray8: '#E8E8E8',
    gray9: '#7A7A7A',
    gray10: '#FAF8F8',
    red: 'rgb(197, 31, 42)',
    red2:'#C51F2A',
    red3:'#DEDEDE',
    blue:'#0B02C1',
    blue2:'#09046F',
    blue3:'#DBE2FC',
    blue4:'#03134F'
  },
  border: {
    very_small: '1px solid #DEDEDE',
    very_small_gray: '1px solid #DCDCDC',
    very_small_gray5: '1px solid #DCDCDC',
    very_small_red2: '1px solid #C51F2A',
    very_small_blue: '1px solid #0B02C1',
    small: '1.5px solid #DCDCDC',
    large: '2px solid #DCDCDC',
    very_large: '3px solid #DCDCDC',
    small_red2: '1.5px solid #C51F2A',
    large_red2: '3px solid #C51F2A',
    small_blue: '1.5px solid #0B02C1',
    small_gray4: '1.5px solid #BFBFBF',
    very_small_gray4: '1px solid #BFBFBF',
  },
};
